import { ReactNode } from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import SalaryComponents from "./SalaryComponents";
import { TesSalaryTableSelectionProvenance } from "../../../tesSalaryTables/tesSalaryTablesApi";

type Props = {
  tesId: string;
  defaultValues?: { [key: string]: string };
  children?: ReactNode;
  hasTesSalaryTableSelection?: boolean;
  onManualBaseComponentChange?: () => void;
  tesSalaryTableProps?: {
    disabled?: boolean;
    tesId?: string | null;
    workTitleId?: string | null;
    date?: Date | null;
    value?: TesSalaryTableSelectionProvenance | null;
    onAvailabilityChange?: (isAvailable: boolean) => void;
    onChange: (payload: {
      selection: TesSalaryTableSelectionProvenance;
      salaryAmount: string;
    }) => void;
  } | null;
};

const EditableSalary = ({
  tesId,
  defaultValues,
  children,
  hasTesSalaryTableSelection,
  onManualBaseComponentChange,
  tesSalaryTableProps,
}: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <FormSection>
      <Grid item xs={4} alignSelf="center" textAlign="end">
        <Typography variant="secondary">
          {t("talentProfile:validFrom")}
        </Typography>
      </Grid>
      <Grid item xs={8} alignSelf="center">
        <Controller
          name="validFrom"
          control={control}
          render={({ field }) => (
            <DesktopDatePicker
              readOnly
              disabled
              value={field.value}
              format="dd.MM.yyyy"
              slots={{ textField: TextField }}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  sx: { input: { textAlign: "center" }, width: "135px" },
                },
              }}
            />
          )}
        />
      </Grid>
      {children}
      <SalaryComponents
        tesId={tesId}
        defaultValues={defaultValues}
        hasTesSalaryTableSelection={hasTesSalaryTableSelection}
        onManualBaseComponentChange={onManualBaseComponentChange}
        tesSalaryTableProps={tesSalaryTableProps}
      />
    </FormSection>
  );
};

export default EditableSalary;
